export const   appLaunch= 'REACT-APP-STARTED'
export const   appNavigation= 'REACT-APP-NAVIGATE'
export const   applicationErrorConfirmed= 'REACT-APP-ERROR-CONFIRMATION'
export const   applicationError= 'REACT-APP-ERROR'
